import React, { useState, useEffect } from 'react'
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"
import Login from './components/Login'
import Dashboard from './components/Dashboard';
import ManageUser from './components/Manage_Users';
import ManageTenant from './components/Manage_Tenants';
import ManageTenantUser from './components/Manage_Tenants_User';
import ProtectedRoute from './ProtectedRoute';
import RoleConfiguration from './components/RoleConfiguration';
import ManageRoleConfiguration from './components/Manage_Role_Config';
import MasterConfiguration from './components/MasterConfiguration';
import Sidebar from './components/Sidebar';
import Topbar from './components/Topbar';
import DashboardVerticalView from './components/DashboardVerticalView';
import NexAdminConfiguration from './components/NexAdminConfiguration';
import Integration from './components/Integration';
import NexadminDashboard from './components/NexadminDashboard';
import NexAdminConfigurationRent from './components/NexAdminConfigurationRent';
import OcrReportTable from './components/OcrReportTable';

const App = () =>  {
    //Function to check fro Inactivity or Autologout
const checkActivity = ()=>{
    //get Expire Time fro localStorage
    const expireTime = localStorage.getItem("expireTime");
    //if expire time is earlier then now log out
    if(localStorage.getItem('isLoggedIn') == "true" && expireTime < Date.now()){
        window.location.href="/sign-in";
        localStorage.clear();
    }
    }
//Function to update expireTime
const UpdateExpireTime = ()=>{
        //set Expire to 10 min for now
        const expireTime = Date.now()+600000;
        //set Expire Time fro localStorage
        localStorage.setItem("expireTime",expireTime);
    }
 //use Effect to setInterval to check Inactivity         
 useEffect(()=>{
        const interval = setInterval(()=>{
            checkActivity();
        },600000)
        return ()=> clearInterval(interval);
    },[]);
 //use Effect To update Expire Time on any user Activity         
 useEffect(()=>{
        UpdateExpireTime();
        //set Event Listener
        window.addEventListener("click",UpdateExpireTime);
        window.addEventListener("keypress",UpdateExpireTime);
        window.addEventListener("scroll",UpdateExpireTime);
        window.addEventListener("mousemove",UpdateExpireTime);
        window.addEventListener("load",UpdateExpireTime);
        //cleanup
        return()=>{
            window.removeEventListener("click",UpdateExpireTime);
            window.removeEventListener("keypress",UpdateExpireTime);
            window.removeEventListener("scroll",UpdateExpireTime);
            window.removeEventListener("mousemove",UpdateExpireTime);
            window.removeEventListener("load",UpdateExpireTime);
        }
    },[]);

    return (
        <div className='App'>
            <Router>
                <Switch>
                    <Route exact path='/sign-in' component={Login} />

                    <ProtectedRoute exact path='/ocrReport' component={OcrReportTable} />
            
                    <ProtectedRoute exact path='/dashboard' component={Dashboard} />
              
                    <ProtectedRoute exact path='/manageuser' component={ManageUser} />
                  
                    <ProtectedRoute exact path='/managetenant' component={ManageTenant} />
                  
                    <ProtectedRoute exact path='/managetenantuser' component={ManageTenantUser} />

                    <ProtectedRoute exact path='/ManageRoleConfiguration' component={ManageRoleConfiguration} />
                  
                    <ProtectedRoute exact path='/MasterConfiguration' component={MasterConfiguration} />

                    <ProtectedRoute exact path='/NexAdminConfiguration' component={NexAdminConfiguration} />

                    <ProtectedRoute exact path='/DashboardVerticalView' component={DashboardVerticalView} />

                    <ProtectedRoute exact path='/NexAdminConfigurationRent' component={NexAdminConfigurationRent} />

                     <ProtectedRoute exact path='/NexadminDashboard' component={NexadminDashboard} /> 
                    
                    {/* <ProtectedRoute exact path='/Integration' component={Integration} /> */}

                    <Route exact path='/' component={Login} />
                </Switch>
            </Router>
      </div>
    )
}
export default App;